import { Box, Text, Flex } from '@chakra-ui/react';
import SkillPhone from './SkillPhone';
import { scrubSelected } from '../utils';

const SkillsBoxPhone = ({ props, qObj, selectedSkills, style }) => {
  const scrubbedSelected = scrubSelected(props,selectedSkills);
  return (
    <Box sx={{ ...style.skillsBox.phoneBox }}>
      <Text sx={{ ...style.skillsBox.phoneBox.text }}>SELECTED</Text>
      <Flex
        sx={{ ...style.skillsBox.phoneBox.flexWrapper }}
        id="selectedSkills"
      >
        {scrubbedSelected.map((skill, i) => {
          return (<SkillPhone props={props} qObj={qObj} skill={skill} style={style} />)
        })}
      </Flex>
    </Box>
  );
};

export default SkillsBoxPhone;
